if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"ai_interview_flowup_0_1_0","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(7(05|14|58)|053|47|603)|2(089|266|564|620)|3(149|201|230)|4(264|626|697|881|934|971)|6(293|381|903|920)|7(341|405|487|83)|5496|5802|9284)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}